// extracted by mini-css-extract-plugin
export var actions = "_1i-0";
export var actionsContainer = "_1i-7";
export var border = "_1i-1";
export var childFullHeight = "_1i-f";
export var collapse = "_1i-2";
export var content = "_1i-a";
export var contentChild = "_1i-e";
export var fullscreen = "_1i-c";
export var hasLeftRadius = "_1i-k";
export var headerContainer = "_1i-3";
export var headerRow = "_1i-5";
export var hidePadding = "_1i-b";
export var navCollapsedGap = "_1i-l";
export var noScrollX = "_1i-m";
export var noScrollY = "_1i-n";
export var noTopPadding = "_1i-i";
export var optOutTopPadding = "_1i-d";
export var pageMain = "_1i-j";
export var pageOuter = "_1i-g";
export var pagePadding = "_1i-8";
export var pageScroll = "_1i-9";
export var profile = "_1i-o";
export var profileContainer = "_1i-p";
export var profileImage = "_1i-q";
export var profileMain = "_1i-r";
export var profileSubtitle = "_1i-t";
export var profileTitle = "_1i-s";
export var showLeftPadding = "_1i-h";
export var tabsPortalSlot = "_1i-6";
export var tabsWrapper = "_1i-4";
export var title = "_1i-u";